import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MarketAnalysisByIndustryComponent } from '../component/market-analysis-by-industry/market-analysis-by-industry.component';
import { MarketAnalysisByVintageComponent } from '../component/market-analysis-by-vintage/market-analysis-by-vintage.component';
import { MaTickersComponent } from '../../recovery/component/recovery-market-analysis/ma-tickers/ma-tickers.component';


export const PP_URLS_MARKET = {
  base: 'market-analysis',
  _industry: 'by-industry',
  _vintage: 'by-vintage',
  _stock: 'by-stock',

};
const routes: Routes = [
  { path: '', redirectTo: PP_URLS_MARKET._vintage, pathMatch: 'full' },
  { path: PP_URLS_MARKET._industry, component: MarketAnalysisByIndustryComponent },
  { path: PP_URLS_MARKET._vintage, component: MarketAnalysisByVintageComponent },
  { path: PP_URLS_MARKET._stock, component: MaTickersComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class MarketAnalysisRoutingModule {
}
